import { Dialog, DialogContent, Divider, Slide } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import Translator from "Languages/Utility/Translator";
import { useTheme } from "@material-ui/core/styles";
import PageTitle from "Components/PageTitle/PageTitle";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { useTranslation } from "react-i18next";
import moment from "moment-jalaali";
import ShareFile from "Helpers/ShareFile";
import { useSelector } from "react-redux";
import * as Icons from "react-bootstrap-icons";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PreviewDialog = ({ open, handleClose, data, shareable = false}) => {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const reportRef = useRef(null);
  const [scale, setScale] = useState(1);
  const [loading, setLoading] = useState(false);

  const { constructionResult, selectedProject } = useSelector((state) => ({
    constructionResult: state.construction.constructionResult,
    selectedProject: state.project.selectedProject,
  }));

  const handlePrint = useReactToPrint({
    content: () => {
      if (reportRef.current) reportRef.current.style.transform = "scale(1)";
      return reportRef.current;
    },
    onBeforeGetContent: () => {
      setLoading(true);
    },
    onAfterPrint: () => {
      if (reportRef.current)
        reportRef.current.style.transform = `scale(${scale})`;
      setLoading(false);
    },
  });

  useEffect(() => {
    if (open) {
      const scaleReport = () => {
        const reportElement = reportRef.current;
        if (reportElement) {
          const container = window.innerWidth;
          const reporter = reportElement.offsetWidth + 80;
          if (container > reporter) {
            setScale(1);
          } else if (reporter > 0) {
            const scaleFactor = container / reporter;
            setScale(scaleFactor);
          }
        }
      };
      setTimeout(scaleReport, 0);
      window.addEventListener("resize", scaleReport);
      return () => window.removeEventListener("resize", scaleReport);
    }
  }, [open]);

  const handleShare = async () => {
    setLoading(true);

    let title_1 = "";
    let title_2 = "";
    switch (constructionResult.action) {
      // -------------------- tab 1
      case 1:
        title_1 = t("ListBoresh");
        title_2 = t("LinedProfile");
        break;
      case 2:
        title_1 = t("ListBoresh");
        title_2 = t("isGlass");
        break;
      case 5:
        title_1 = t("ListBoresh");
        title_2 = t("isNet");
        break;
      case 30:
        title_1 = t("ListBoresh");
        title_2 = t("UnitedProfile");
        break;
      // -------------------- tab 2
      case 6:
        title_1 = t("optimization");
        title_2 = t("isProfile");
        break;
      case 9:
        title_1 = t("optimization");
        title_2 = t("behinehSaziGalvanize");
        break;
      // -------------------- tab 3
      case 12:
        title_1 = t("AglamMasrafi");
        title_2 = t("general_consumable");
        break;
      case 13:
        title_1 = t("AglamMasrafi");
        title_2 = t("per_unit_consumable");
        break;
      case 14:
        title_1 = t("AglamMasrafi");
        title_2 = t("technical_fittings");
        break;
      case 15:
        title_1 = t("AglamMasrafi");
        title_2 = t("general_fittings");
        break;
      case 16:
        title_1 = t("AglamMasrafi");
        title_2 = t("per_unit_fittings");
        break;
      // -------------------- tab 4
      case 17:
        title_1 = t("controlkeyfiat");
        title_2 = t("QC_prj_Label");
        break;
      case 18:
        title_1 = t("controlkeyfiat");
        title_2 = t("QC_glass_Label");
        break;
      case 19:
        title_1 = t("controlkeyfiat");
        title_2 = t("unit_images");
        break;
      default:
        title_1 = "*";
        title_2 = "*";
        break;
    }
    ShareFile(
      "printPaper_construction",
      `${t("production")}_${title_1}_${title_2}_${
        selectedProject.Name ? selectedProject.Name : ""
      }_${moment(new Date()).format("jYYYY/jM/jD")}`,
      `${t("production")} ${title_1} ${title_2} ${t("projects")} ${
        selectedProject.Name ? selectedProject.Name : ""
      } ${t("moreInfoInShare")}`
    );
    setLoading(false);
  };

  return (
    <Dialog
      dir={direction}
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <div className="dialogHeader mb-2">
        <BackDropLoading loading={loading} />
        <div className="page-top-title-button w-100">
          <PageTitle title={<Translator id="preview" />} />
          <div className="report-buttons">
            <MuiIconButton
              onClick={handleShare}
              title={<Translator id="share" />}
              className="primary-button"
              icon={<Icons.Share size={17} />}
              hidden={!shareable}
            />
            <MuiIconButton
              onClick={handlePrint}
              title={<Translator id={"print"} />}
              className="primary-button"
              icon={<Icons.Printer size={17} />}
            />
            <Divider
              orientation="vertical"
              flexItem
              className="divider-factor"
            />
            <MuiIconButton
              onClick={handleClose}
              title={<Translator id="enseraf" />}
              className="danger-fill"
              icon={<Icons.XLg sizeå={17} />}
            />
          </div>
        </div>
      </div>
      <DialogContent className="p-2">
        <div className="printPaper">
          <div
            className="inner-page"
            id="printPaper_construction"
            ref={reportRef}
            style={{ transform: `scale(${scale})` }}
            dangerouslySetInnerHTML={{ __html: data }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PreviewDialog;
